// 분석 보고서(bito 분석 보고서) MVP API. bito 분석 보고서 MVP(2026-10-26).
import client from './client';

const base = '/api/v1/report';

// 템플릿 고르기/필드 선택 화면 - 검색창 없음(R10). 이 API가 메뉴/필드 권한으로 이미 걸러서 내려준다.
export const getTemplates = () => client.get(`${base}/templates`);
export const getFields = (tmplCd) => client.get(`${base}/templates/${tmplCd}/fields`);

// 실행 - 애드혹(미리보기)과 저장 보고서 보기/내보내기가 전부 같은 SQL 1문을 거친다(R3).
export const runAdhoc = (tmplCd, selection) => client.post(`${base}/run`, { tmplCd, selection });
export const runSaved = (rptUuid, runSrc = 'VIEW') =>
  client.post(`${base}/saved/${rptUuid}/run`, null, { params: { runSrc } });

// 저장 보고서 CRUD.
export const listSaved = (mine) =>
  client.get(`${base}/saved`, { params: mine === undefined ? {} : { mine } });
export const getSaved = (rptUuid) => client.get(`${base}/saved/${rptUuid}`);
export const createSaved = (body) => client.post(`${base}/saved`, body);
export const updateSaved = (rptUuid, body) => client.put(`${base}/saved/${rptUuid}`, body);
export const deleteSaved = (rptUuid) => client.delete(`${base}/saved/${rptUuid}`);
export const copySaved = (rptUuid) => client.post(`${base}/saved/${rptUuid}/copy`);
